function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#434546",
  d: "M290.25,429.72v-18h11.53l4.59,5.06V429.7Zm1-17v16l14.13,0V417.2l-4-4.44Z",
  transform: "translate(-290.25 -411.76)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#434546",
  points: "15.83 5.75 10.71 5.75 10.71 0.69 11.71 0.69 11.71 4.75 15.83 4.75 15.83 5.75"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#434546",
  d: "M298.31,418.84a3.38,3.38,0,1,0,3.38,3.38A3.38,3.38,0,0,0,298.31,418.84Zm1.34,3.49-2,1.27-.08,0-.07,0a.14.14,0,0,1-.07-.12V421a.14.14,0,0,1,.22-.12l2,1.27a.14.14,0,0,1,0,.24Z",
  transform: "translate(-290.25 -411.76)"
});

var SvgFilesListingVideo = function SvgFilesListingVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.13 17.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_video.73ed5d6a.svg";
export { ForwardRef as ReactComponent };